export type Mode = 'rebus' | 'concept';

export interface EmojiAnagramLevel {
  mode?: string;
  emojis?: string[];
  answer?: string;
  hint?: string;
  difficulty?: number;
}

export interface NormalizedEmojiAnagram {
  mode: Mode;
  emojis: string[];
  answer: string;
  answerStripped: string;
  wordLengths: number[];
  uniqueLetters: Set<string>;
  hint: string;
  difficulty: number;
}

export function normalize(level: EmojiAnagramLevel): NormalizedEmojiAnagram | null {
  const modeRaw = (level.mode ?? '').toUpperCase();
  if (modeRaw !== 'REBUS' && modeRaw !== 'CONCEPT') return null;
  const emojis = level.emojis ?? [];
  if (emojis.length === 0) return null;
  const answer = (level.answer ?? '').toUpperCase();
  if (!answer) return null;
  const hint = level.hint ?? '';
  const difficulty = level.difficulty ?? 2;
  const stripped = answer.replace(/ /g, '');
  const wordLengths = answer.split(' ').map((w) => w.length);
  const uniqueLetters = new Set(stripped.split(''));
  return {
    mode: modeRaw === 'REBUS' ? 'rebus' : 'concept',
    emojis,
    answer,
    answerStripped: stripped,
    wordLengths,
    uniqueLetters,
    hint,
    difficulty,
  };
}
